export const  formatNumberWithCurrency = (value) => {
    if (typeof value !== 'number') {
        throw new Error('El valor debe ser un número');
    }
    
    return value.toFixed(2) + ' mx';
}